export function timeFormat24h(date: string): string {
  if (!date) return ''
  let dateString: string = (date.length === 10) ? `${date}T00:00:00.000Z` : date
  let dateValue: Date = new Date(dateString)
  let hours: string = dateValue.getUTCHours().toString().padStart(2, '0')
  let minutes: string = dateValue.getUTCMinutes().toString().padStart(2, '0')

  return `${hours}:${minutes} h`
}

export function timeFormat12h(date: string): string {
  if (!date) return ''
  let dateString: string = (date.length === 10) ? `${date}T00:00:00.000Z` : date
  let dateValue: Date = new Date(dateString)
  let hours: number = dateValue.getUTCHours()
  let minutes: string = dateValue.getUTCMinutes().toString().padStart(2, '0')
  let period: string = (hours >= 12) ? 'pm' : 'am'

  return `${hours % 12 || 12}:${minutes} ${period}`
}

export function dateFormatLocalized(lang_code: string, date: string): string {
  if (!date) return ''
  let separator: Record<string, string> = {
    EN: '-',
    ES: '/',
    FR: '.',
    IT: '/',
    DE: '.'
  }

  let dateString: string = (date.length === 10) ? `${date}T00:00:00.000Z` : date
  let dateValue: Date = new Date(dateString)
  let day: string = dateValue.getUTCDate().toString().padStart(2, '0')
  let month: string = (dateValue.getUTCMonth() + 1).toString().padStart(2, '0')
  let year: string = dateValue.getUTCFullYear().toString()

  return `${day}${separator[lang_code]}${month}${separator[lang_code]}${year}`
}

export function dateFormat(lang_code: string, date: string): string {
  if (!date) return ''
  let list: Record<string, string[]> = {
    EN: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    FR: ['Janv', 'Févr', 'Mars', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'],
    ES: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    IT: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
    DE: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez']
  }

  let dateString: string = (date.length === 10) ? `${date}T00:00:00.000Z` : date
  let dateValue: Date = new Date(dateString)
  let day: string = dateValue.getUTCDate().toString().padStart(2, '0')
  let month: string = (dateValue.getUTCMonth() + 1).toString().padStart(2, '0')
  let year: string = dateValue.getUTCFullYear().toString()

  month = list[lang_code][dateValue.getUTCMonth()]

  return `${day} ${month} ${year}`
}

export function datetimeFormat24h(lang_code: string, date: string): string {
  if (!date) return ''
  return `${dateFormat(lang_code, date)}, ${timeFormat24h(date)}`
}

export function datetimeFormat12h(lang_code: string, date: string): string {
  if (!date) return ''
  return `${dateFormat(lang_code, date)}, ${timeFormat12h(date)}`
}
